import { useLanguage } from './LanguageProvider';
import './language-switch.css';

export function LanguageSwitch({ className = '' }: { className?: string }) {
  const { language, toggleLanguage } = useLanguage();
  const targetLanguage = language === 'ru' ? 'English' : 'Русский';

  return (
    <a
      href="#language"
      className={`lovo-language-switch ${className}`.trim()}
      aria-label={language === 'ru' ? 'Switch interface to English' : 'Переключить интерфейс на русский'}
      title={targetLanguage}
      onClick={(e) => {
        e.preventDefault();
        toggleLanguage();
      }}
    >
      {language === 'ru' ? 'EN' : 'RU'}
    </a>
  );
}
